import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavTabService } from '@app/core/navTab.service';
import { KycService } from '@app/core/kyc.service';

@Component({
  selector: 'app-nav-tab',
  templateUrl: './nav-tab.template.html'
})

export class NavTabComponent {
  constructor(
    private router: Router,
    private navTabService: NavTabService,
    private kycService: KycService) {
  }

  onTabClicked(url: string, key: string) {
    let allowToNavigate = true;

    switch (key) {
      case 'coverage':
        allowToNavigate = this.kycService.kyc.profile.completed;
        break;
      case 'needs':
        allowToNavigate = this.kycService.kyc.coverage.completed;
        break;
      case 'submit':
        // already has email
        if (this.kycService.kyc.save.completed) {
          allowToNavigate = false;
          this.navTabService.setActiveTab(key);
          this.router.navigate(['journey', 'thank-you']);
          break;
        }

        if (!this.kycService.kyc.profile.emailInvalid) {
          allowToNavigate = false;
        }

        break;
      default: break;
    }

    if (allowToNavigate) {
      this.navTabService.setActiveTab(key);
      this.router.navigateByUrl(url);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/nav-tab/nav-tab.component.ts